<template>
    <div ref="offlineForm" class="offlineMessage" :class="{ 'success_bg': message_sent }">
        <div v-if="!message_sent" class="message-wrapper-offline" :aria-label="$gettext('Información del formulario offline')"  aria-live="assertive">
          <div class="sad-icon"></div>
          <div class="text-container" tabindex="0">
            <div class="top-text">
                <p><strong>{{ $gettext('En este momento no hay agentes disponibles') }}</strong></p>
            </div>
            <div class="bottom-video">
                <p>{{ $gettext('Completa el formulario adjunto y nos pondremos en contacto contigo lo antes posible') }}</p>
              <p></p>
            </div>
          </div>
          <br>
        </div>

        <div v-if="!message_sent && contactPhone && formattedBusinessHours" class="message-wrapper-offline" :aria-label="$gettext('Información de contacto alternativa')"  aria-live="assertive">
          <div class="phone-icon"></div>
          <div class="text-container" tabindex="0">
            <p>{{ $gettext('También puedes llamarnos al') }} <strong>{{ contactPhone }}</strong> {{ $gettext('en nuestro horario de atención, de') }} {{ formattedBusinessHours }}</p>
          </div>
          <br>
        </div>

        <div v-if="!message_sent" class="form-group">
            <div class="separator">
                <p>{{ $gettext('Formulario de contacto') }}</p>
            </div>
            <div class="form-control">
                <label for="name">{{ $gettext('Nombre') }}</label>
                <input
                    v-model="message.name"
                    @focusout="trimAndValidate('name')"
                    :class="{ 'error': !props.name.valid }"
                    :type="props.name.type"
                    :maxlength="props.name.max_length"
                    :aria-label="$gettext('Nombre')"
                    name="name" />
                <div class="error-message-container" v-if="!props.name.valid">
                    <i class="error-message error-message-icon icon-message-info"></i>
                    <p class="error-message">{{ $gettext('Por favor, rellena este campo') }}</p>
                </div>
            </div>
            <div class="form-control">
                <label for="lastname">{{ $gettext('Apellido') }}</label>
                <input
                    v-model="message.lastname"
                    @focusout="trimAndValidate('lastname')"
                    :class="{ 'error': !props.lastname.valid }"
                    :type="props.lastname.type"
                    :maxlength="props.lastname.max_length"
                    :aria-label="$gettext('Apellido')"
                    name="lastname" />
                <div class="error-message-container" v-if="!props.lastname.valid">
                    <i class="error-message error-message-icon icon-message-info"></i>
                    <p class="error-message">{{ $gettext('Por favor, rellena este campo') }}</p>
                </div>
            </div>
            <div class="form-control">
              <label for="email">{{ $gettext('Correo electrónico') }}</label>
              <input 
                v-model="message.email" 
                @focusout="validateProp('email')" 
                :class="{ 'error': !props.email.valid }"
                :type="props.email.type" 
                :maxlength="props.email.max_length" 
                :aria-label="$gettext('Correo electrónico')" 
                name="email" />

              <div class="error-message-container" v-if="!props.email.valid">
                <i class="error-message error-message-icon icon-message-info"></i>
                <p class="error-message">{{ $gettext('Por favor, introduce una dirección de correo electrónico válida')
                  }}</p>
              </div>

            </div>
            <div class="form-control">
                <label for="phone">{{ $gettext('Teléfono') }}</label>
                <vue-tel-input
                    v-model="message.phone_input"
                    v-bind="vueTel"
                    @open="onDropdownOpen(true)"
                    @close="onDropdownOpen(false)"
                    @blur="validateProp('phone')"
                    :defaultCountry="$store.state.phone_prefix"
                    :styleClasses="{ 'error': !props.phone.valid }"
                    @input="phoneChange"
                    name="phone"
                >
                    <template v-slot:arrow-icon>
                        <span>{{ open ? '▲' : '▼' }}</span>
                    </template>
                </vue-tel-input>
                <div class="error-message-container" v-if="!props.phone.valid">
                    <i class="error-message error-message-icon icon-message-info"></i>
                    <p class="error-message">{{ $gettext('Por favor, introduce una número de teléfono válido') }}</p>
                </div>

                <!-- <VueTelInput v-model="message.phone"
                       @phone-number-focused="validateProp('phone')"
                       :class="{ 'error': !props.phone.valid }"
                       :type="props.phone.type" 
                       :maxlength="props.phone.max_length"
                       @keyup="cleanPhone('phone', message.phone)"
                       :placeholder="$gettext('Teléfono')" /> -->
            </div>

            <IncidentInteractionInputs
                v-if="!hideIncidentInteractions && hasIncidentInteractions"
                v-model="message"
                :message_properties="props" />

            <div class="form-control" v-else>
                <label for="query-subject">{{ $gettext('Asunto de tu consulta') }}</label>
                <input
                    v-model="message.subject"
                    @focusout="trimAndValidate('subject')"
                    :class="{ 'error': !props.subject.valid }"
                    :type="props.subject.type"
                    :maxlength="props.subject.max_length"
                    :aria-label="$gettext('Asunto de tu consulta')"
                    name="subject" />
                <div class="error-message-container" v-if="!props.subject.valid">
                    <i class="error-message error-message-icon icon-message-info"></i>
                    <span class="error-message">{{ $gettext('Por favor, selecciona un tipo de consulta') }}</span>
                </div>
            </div>

            <div class="form-control">
                <label for="query-detail">{{ $gettext('Detalle consulta') }}</label>
                <textarea
                    v-model="message.message"
                    @focusout="trimAndValidate('message')"
                    :class="{ 'error': !props.message.valid }"
                    :aria-label="$gettext('Detalle consulta')"
                    name="message">
                </textarea>
                <div class="error-message-container" v-if="!props.message.valid">
                    <i class="error-message error-message-icon icon-message-info"></i>
                    <p class="error-message">{{ $gettext('Por favor, rellena este campo') }}</p>
                </div>
            </div>

            <div class="form-control d-block">
                <div tabindex="0" >
                    {{ $gettext('Al hacer click en "Enviar" acepto:') }} <a :href="this.policyUrl" target="_blank" rel="noopener">{{ $gettext('Política de privacidad') }}</a> {{ $gettext('y') }} <a :href="this.dataProtectionUrl" target="_blank" rel="noopener">{{ $gettext('Política de protección de datos') }}</a>.
                </div>
<!--                <div class="checkbox-form">-->
<!--                    <div>-->
<!--                        <input type="checkbox" :checked="newsletter_checked"-->
<!--                            @click="newsletterCheck" @keyup.enter="newsletterCheck" @keyup.space="newsletterCheck" aria-label="newsletter-checbox" />-->
<!--                    </div>-->
<!--                    <label class="checkbox-label"-->
<!--                        v-html="$gettextInterpolate($gettext('Acepto recibir comunicaciones comerciales de IKEA, pudiendo darme de baja fácilmente en cualquier momento'))"-->
<!--                        for="newsletter-checbox"-->
<!--                    >-->
<!--                    </label>-->
<!--                </div>-->
                <div>
                    <div class="error-message-container" v-if="newsletter_error">
                        <i class="error-message error-message-icon icon-message-info"></i>
                        <p class="error-message">{{ $gettext('Por favor, acepte los terminos y condiciones') }}</p>
                    </div>
                </div>
            </div>
            
            <div v-if="message_error" class="warning_bg warning_message">
                <i class="waiting-icon icon-message-info"></i>
                <div v-html="message_error">
                </div>
            </div>

            <div class="form-control">
              <div class="button-container">
                <button 
                    @click.prevent="cancelForm" 
                    class="cancel"
                    name="cancelForm">
                  {{ $gettext('Cancelar') }}
                </button>
                <button
                    @click.prevent="sendMessage"
                    :disabled="sending"
                    :class="{ 'checked': true, 'sending': sending }"
                    class="send"
                    name="sendMessage">
                  <span v-if="sending" class="send-spinner icon-loading" aria-hidden="true"></span>
                  {{ sending ? $gettext('Enviando…') : $gettext('Enviar') }}
                </button>
              </div>
            </div>
        </div>
        <div class="offline-container" v-else>
          <div class="message-wrapper-offline success">
            <i class="waiting-icon icon-message-confirmation"></i>
            <div class="text-container">
              <p tabindex="0"><strong>{{$gettext('Tu consulta ha sido enviada.')}}</strong></p>
              <p tabindex="0">{{$gettext('Te contactaremos lo antes posible. ¡Gracias por tu paciencia!')}}</p>
            </div>
          </div>


          <div class="form-button-container">
            <button 
                @click="closeChat"
                name="closeChat">{{$gettext('Volver al inicio')}}</button>
          </div>
        </div>

    </div>
</template>

<script>

import { mapGetters, mapActions } from 'vuex'
import IncidentInteractionInputs from "@/components/IncidentInteractionInputs";
import { VueTelInput } from 'vue-tel-input';
import { readDraft, saveDraft, clearDraft, confirmDiscard } from '@/services/offlineFormDraft';

export default {
    name: "OfflineMessageForm",
      components: { VueTelInput,  IncidentInteractionInputs  },
    data() {
        return {
            newsletter_checked: false,
            newsletter_error: false,
            message_sent: false,
            message_error: null,
            sending: false,
            message: {
                name: null,
                lastname: null,
                phone: null,
                email: null,
                subject: null,
                message: null,
                interaction: null,
                motive: null,
                phone_input: null
            },
            props: {
                name: { valid: true, required: true, type: 'text', max_length: 20 },
                lastname: { valid: true, required: true, type: 'text', max_length: 20 },
                phone: { valid: true, required: true, type: 'phone', min_length: 6, max_length: 20 },
                email: { valid: true, required: true, type: 'email' },
                subject: { valid: true, required: true, type: 'text', max_length: 30 },
                interaction: { valid: true, required: true },
                motive: { valid: true, required: true },
                message: { valid: true, required: true, type: 'text' },
            },
            vueTel: {
                preferredCountries: ["ES", "US", "GB"],
                defaultCountry: null,
                disabledFetchingCountry: false,
                mode: "auto",
                dropdownOptions: {
                    showDialCodeInList: true,
                    showDialCodeInSelection: true,
                    showFlags: true,
                },
                inputOptions: {
                    maxLen: 20,
                    tabindex: 0,
                    'aria-label': this.$gettext('Teléfono'),
                },
                wrapperClasses: "country-phone-input",
                type: 'phone',
                required: true
            },
            open: false
        };
    },
    computed: {
        ...mapGetters(['policyUrl', "dataProtectionUrl", 'incidentInteractions', 'hideIncidentInteractions', 'contactPhone', 'formattedBusinessHours']),
        ...mapActions(['sendOfflineMessage', 'closeForm']),
        hasIncidentInteractions() {
            return this.incidentInteractions &&
                   this.incidentInteractions.topics &&
                   Array.isArray(this.incidentInteractions.topics) &&
                   this.incidentInteractions.topics.length > 0;
        }
    },
    props: ['label', 'desc'],
    watch: {
      'message.phone_input': function(newValue) {
        const spanText = document.getElementsByClassName('.vti__dropdown-item')
      },
      message: {
        deep: true,
        handler(newVal) {
          if (this.message_sent) return;
          saveDraft(newVal);
        }
      }
    },
    mounted() {
        this.$store.http.getIncidentInteractions();
        this.resetMessage();
        this.restoreFormData();
    },
    methods: {
        restoreFormData() {
            const data = readDraft();
            if (!data) return;
            Object.keys(data).forEach((key) => {
                if (key in this.message) {
                    this.message[key] = data[key];
                }
            });
        },
        trimAndValidate(prop) {
            // Trim whitespace from text fields
            if (this.message[prop] && typeof this.message[prop] === 'string') {
                this.message[prop] = this.message[prop].trim();
            }
            // Then validate the field
            this.validateProp(prop);
        },
        phoneChange(number, phoneObject) {
            this.message.phone = phoneObject.number;
            this.highlightDropdownItem();
        },
        onDropdownOpen() {
            this.open = !this.open
            if (this.open) {
              this.highlightDropdownItem();
            }
        },
        highlightDropdownItem() {
          this.$nextTick(() => {
            const selectedCountry= document.querySelector('.vti__country-code')?.innerText;
            const countryList = document.querySelectorAll('.vti__dropdown-item');

            countryList.forEach(country => {
              if (country) {
                if (country.innerText.includes(selectedCountry)) {
                  country.classList.add('highlighted');
                } else {
                  country.classList.remove('highlighted');
                }
              }
            });
          });
        },
        sendMessage() {
            // Candado anti doble-envío: si ya hay una request en vuelo, ignorar clicks extra
            if (this.sending) return;
            this.message.groupid = this.$store.state.groupId;
            if (this.validateData()) {
                this.sending = true;
                this.message_error = null;
                this.$store.dispatch('sendOfflineMessage', {
                    message: this.message,
                    callback: (response) => {
                        this.sending = false;
                        let data = response.data;
                        if (data.success) {
                            this.messageSent();
                        } else {
                            if (data.show_message) {
                                this.message_error = data.message;
                            } else {
                                this.message_error = this.$gettext('Ha ocurrido un error al intentar enviar su mensaje.');
                            }
                        }
                    },
                    errback: () => {
                        this.sending = false;
                        this.message_error = this.$gettext('Ha ocurrido un error al intentar enviar su mensaje.');
                    }
                });
            } else {
                this.$nextTick(() => {
                    var container = this.$refs['offlineForm'].closest(".content");
                    var qs = this.$refs['offlineForm'].querySelector(".error");
                    var pos = null;
                    if (qs) {
                        pos = qs.closest(".form-control").offsetTop;
                    }
                    if (container != undefined) {
                        container.scrollTop = pos;
                    }
                })
            }
        },
        messageSent() {
            this.resetMessage();
            clearDraft();
            this.message_sent = true;
        },
        validateData() {
            var valid = true;
            Object.keys(this.props).forEach((prop) => {
                if (!this.validateProp(prop)) {
                    valid = false;
                }
            })
            return valid;
        },
        closeChat() {
          this.closeForm();
        },
        newsletterCheck() {
            this.newsletter_checked = !this.newsletter_checked;
            this.newsletter_error = false;
        },
        validateProp(prop) {
            var prop_val = this.message[prop] ? this.message[prop] : "";
            var prop_type = this.props[prop].type;

            var valid = true;

            if (this.props[prop].required && (!prop_val || prop_val.length == 0)) {
                valid = false;
            }
            if (valid) {
                switch (prop_type) {
                    case "text":
                        break;
                    case "email":
                        valid = this.validEmail(prop_val);
                        break;
                    case "phone":
                        prop_val = this.cleanPhone(prop, prop_val);
                        break;
                }
            } else if (prop == 'motive') {
                if (this.incidentInteractions.length == 0) {
                    valid = true;
                }
            }
            if (
                (this.props[prop].max_length && prop_val.length > this.props[prop].max_length)
                ||
                (prop_val.length > 0 && this.props[prop].min_length && prop_val.length < this.props[prop].min_length)) {
                valid = false;
            }

            this.props[prop].valid = valid;
            return valid;
        },
        validEmail(email) {
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(email);
        },
        cleanPhone(prop, value) {
            value = value ? value : '';
            let aux = value.match(/([0-9]|\+)/g);
            aux = aux ? aux : [];
            value = aux.join('').substring(0, this.props[prop].max_length);
            this.$set(this.message, prop, value);
            return value;
        },
        resetMessage() {
            Object.keys(this.props).forEach((prop) => {
                this.props[prop].valid = true;
            });
            // Driven by message, not props: phone_input and the runtime groupid have no props entry.
            Object.keys(this.message).forEach((key) => {
                this.message[key] = null;
            });
            this.message_sent = false;
            this.message_error = false;
        },
        cancelForm() {
            confirmDiscard(
                this,
                this.$gettext('¿Seguro que quieres cancelar? Se perderán los datos del formulario.'),
                () => this.closeForm()
            );
          }
    }
}

</script>

<style scoped>
.country-phone-input .dropdown:focus {
    outline: none;
    color: grey;
}

.send.sending {
    opacity: 0.85;
    cursor: not-allowed;
}

.send-spinner {
    display: inline-block;
    margin-right: 6px;
    animation: send-spin 0.8s linear infinite;
}

@keyframes send-spin {
    from { transform: rotate(0deg); }
    to { transform: rotate(360deg); }
}
</style>
